import { useSelector } from "react-redux";
import {  onDragStart, onDragEnd, onDragEnter, onDragLeave } from "../../util/helper/helperFunctions";
import infoIcon from "../../assets/icons/info.png";
import "../../assets/css/Status/removedStatus.css";

const Loader = () => (
  <div className="rm-loader">
    <h4 data-testid="loading-text">Loading...</h4>
    <div className="spinner"></div>
  </div>
);

const NoRemovedLGVs = (scrollable) => (
  <div
    className={`rm-status-section ${
      scrollable ? "rm-status-section-wrap" : ""
    } `}
  >
    <div className="empty-removed-status-container">
      <p>No Removed LGVs at the moment.</p>
    </div>
  </div>
);

const formatDuration = (minutes) => {
  if (minutes >= 1440)
    return (
      <>
        <span className="rm-status-duration-number">
          {Math.floor(minutes / 1440)}
        </span>
        <span className="rm-status-duration-duration">
          day{minutes >= 2880 ? "s" : ""}
        </span>
      </>
    );
  if (minutes >= 60)
    return (
      <>
        <span className="rm-status-duration-number">
          {Math.floor(minutes / 60)}
        </span>
        <span className="rm-status-duration-duration">
          hour{minutes >= 120 ? "s" : ""}
        </span>
      </>
    );
  return (
    <>
      <span className="rm-status-duration-number">{minutes}</span>
      <span className="rm-status-duration-duration">
        min{minutes !== 1 ? "s" : ""}
      </span>
    </>
  );
};

const RemovedLGVStatus = ({ scrollable }) => {
  const { loading: fleetCountLoading, data: fleetCount } = useSelector(
    (state) => state.dashboard.fleetCount
  );
  const { loading: fleetStatusLoading, data: fleetStatus } = useSelector(
    (state) => state.dashboard.fleetStatus
  );

  const renderFleetCount = () => {
    const lgvCount = Array.isArray(fleetStatus) ? fleetStatus?.length : 0;
    const fleetLength = Array.isArray(fleetCount)
      ? fleetCount?.[0]?.fleetSize
      : 0;
    return (
      <p data-testid="empty-removed-lgv">
        {`${lgvCount} LGVs Out of System (Fleet Size: ${fleetLength})`}
      </p>
    );
  };

  const renderFleetStatus = () =>
    Array.isArray(fleetStatus) && fleetStatus?.length > 0 ? (
      <div
        className={`rm-status-section ${
          scrollable ? "rm-status-section-wrap" : ""
        } `}
      >
        {fleetStatus
          ?.toSorted((prev, next) => next.duration - prev.duration)
          ?.map(({ lgv, duration }, index) => (
            <div
              data-testid="empty-removed-lgv"
              key={index}
              className="status-box"
            >
              <div className="status-top-section">
                <span data-testid="fleet-status-test-id">LGV: {lgv}</span>
              </div>
              <div className="status-bottom-section">
                {formatDuration(duration)}
              </div>
            </div>
          ))}
      </div>
    ) : (
      <NoRemovedLGVs scrollable={scrollable} />
    );

  return (
    <div
      draggable
      onMouseDown={(event) => onDragStart(event)}
      onMouseUp={(event) => onDragEnd(event)}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      className="rm-lgv-fleet-status-container"
    >
      {fleetCountLoading ? (
        <Loader />
      ) : (
        <div className="fleet-container">
          <div className="fleet-status">
            <img src={infoIcon} alt="Info Icon" />
            {renderFleetCount()}
          </div>
        </div>
      )}
      {fleetStatusLoading ? (
        <Loader />
      ) : (
        <div className="rm-status-container">
          <div className="rm-header-section">
            <h4>Removed LGV Status Time</h4>
          </div>
          {renderFleetStatus()}
        </div>
      )}
    </div>
  );
};

export default RemovedLGVStatus;
